import {type FunctionalComponent, h,type VNode} from '@stencil/core';
import type { GuidedApiSuggestion } from '../api';

export interface SearchHitoryProps{
    history: Array<GuidedApiSuggestion>,
    labelProvider: CallableFunction,
    clickHandler: CallableFunction,
}
export const SearchHistory:FunctionalComponent<SearchHitoryProps> = (props) => {

    const labelProvider = props.labelProvider;
    const clickHandler = props.clickHandler;
    const history = props.history;

    const historyLabel = labelProvider('searchHistory', 'Recent Searches');
    return <div class="guided-pane__quick-links">
      <div class="guided-pane__search-history-section-label">
        {historyLabel}
      </div>
      <div class="guided-pane__quick-links-section">
        <ul class="guided-pane__quick-links-list">
          {history.map(entry =>
            <li
              class="guided-pane__search-history-section-item"
              onClick={(e) => clickHandler(entry, e)}>
              <a class="guided-pane__search-history">
                <div class="guided-pane__quick-link-container">
                  <div class='guided-pane__quartz-icon-wrapper'>
                    <se-icon size="micro">history</se-icon>
                  </div>
                  <p class="guided-pane__search-history-p">{entry.description}</p>
                </div>
              </a>
            </li>
          )}
        </ul>
      </div>
    </div> as VNode;
};
